<template>
  <div class="w-full max-w-full flex flex-col gap-2 p-4 bg-[--fundoForm] rounded-[10px] bg-opacity-[0.55]">
    <div class="w-full flex justify-between items-center mb-4">
      <h3 class="text-lg font-bold text-[--titulo]">Stock do Armazém</h3>
      <div>
        <AppButton v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close" @close="close"
          :width=20 :height=20 />
      </div>
    </div>

    <!-- Tabela de Artigos -->
    <div v-if="armazemId!=0" class="mt-6 w-full">
      <!-- <AppTable :visibility="true" :show="true" :table_data="artigos" :columns="columnsArtigos"
        table_title="Artigos no Armazém" @row-clicked="selectArtigo" /> -->

      <AppTablePagination :visibility="true" :show="true"
            table_title="Artigos do Armazém" @row-clicked=""
            @close="" :groupby="{show:true, field:'equipamento'}" :urlString="urlString" :refresh="refresh" @refreshes="refresh=false" :confirmationProps="popUp"
            :queryCampo="{ campo: 'armazem_filtro', valor: 'armazem_viatura' }" />
    </div>
    <div v-else class="mt-6">
      <p class="text-white">Nenhum artigo encontrado neste armazém.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AppTable from '@/components/tables/table.vue';
import AppButton from '@/components/updated/button.vue';
import { toast } from 'vue3-toastify';
import AppTablePagination from '@/components/tablePagination/tablePagination.vue';

export default {
  name: 'armazemEstoque',
  components: {
    AppTable,
    AppButton,
    AppTablePagination
  },
  props: {
    armazemId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_URL_BASE,
      artigos: [],
      columnsArtigos: [
        { label: 'ID', field: 'id' },
        { label: 'Fornecedor', field: 'fornecedor_nome' },
        { label: 'Tipo Artigo ID', field: 'tpArtigo_id' },
        { label: 'Equipamento', field: 'equipamento_nome' },
        { label: 'Quantidade', field: 'quantidade' },
      ],
      refresh: false,
      urlString:"",
    };
    
  },
  methods: {

    async fetchArtigos() {
      try {
        const res = await axios.get(`${this.baseURL}/api/v1/armazem/${this.armazemId}/estoque/`);
        if (res.status === 200 && res.data.artigos.length > 0) {
          this.artigos = res.data.artigos.map(artigo => ({
            id: artigo.id,
            // tpArtigo_id: artigo.tpArtigo_id,
            equipamento: artigo.equipamento_nome,
            numeroSerie: artigo.numeroSerie,
            codigoBarra: artigo.codigoBarra,
            status: artigo.status,
            //fornecedor: artigo.fornecedor_nome,
            // quantidade: artigo.quantidade
          }));
        } else {
          this.artigos = [];
          toast.warning('Nenhum artigo encontrado neste armazém!', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
      } catch (error) {
        console.error(error);
        toast.error('Erro ao buscar artigos do armazém!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },
    close() {
      this.$emit('close');
    },
  },
  created() {
    //this.fetchArtigos();
    this.urlString = `armazem/${this.armazemId}/estoque`;

  },

  watch:{
    armazemId(){
      this.urlString = `armazem/${this.armazemId}/estoque`;
    }
  }
};
</script>
